export default {
      id: "reset-usage",
      viewBox: "0 0 450 450",
      url: __webpack_public_path__ + "img/icons.a13474e0.svg#reset",
      toString: function () {
        return this.url;
      }
    }